import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { AssetResponse } from "app/core/models/asset-response";

@Injectable()
export class AssetService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getAssets(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<AssetResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/ewan/assets`, {
      params: params
      }).pipe(
          
          map(res =>  <AssetResponse>res)
      );
  }

  getAssetStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/assets/status`);
  }

  getAssetSource(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/ewan/assets/source`);
}

  getAssetsList(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/assets`);
  }

  getAsset(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/ewan/assets/${id}`);
  }

  createAsset(asset: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/ewan/assets`, asset);
  }

  editAsset(asset: any, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/ewan/assets/${id}`, asset);
  }

  deleteAsset(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/ewan/assets/${id}`);
  }
  
}
